export default "/images/vendor/flag-icons/flags/1x1/pl.svg?cd835d05865e496ff6b868655a4c8856";